<template>
  <div class="con-right">
    <!-- <el-button icon="el-icon-star-off">收藏</el-button>
    <el-button icon="el-icon-delete">删除</el-button>
    <el-button icon="el-icon-share">分享</el-button> -->

    <div class="con-right-box">
      <div class="files-table" v-loading="$store.state.tableData_loading_collection">
        <div class="cloud_file_header lately_file_header">
          <div class="cloud_path">
            <span>我的收藏</span>
          </div>
          <div class="cloud_right">
            <div class="cloud_right_add" id="shoucang_right_refresh" style="margin-left: 20px;" @click="refresh_lists_btn_sc">
              <img src="@/assets/images/cloud/refresh.png" alt="">
              <span>刷新</span>
            </div>
            <div class="cloud_right_add" id="shoucang_right_sort" style="margin-left: 20px;position: relative;">
              <el-dropdown trigger="click" @command="dropdown_sort_btn_sc">
                <span class="el-dropdown-link" style="display:flex;align-items: center;">
                  <img src="@/assets/images/cloud/sort.png" alt="">
                  <span>排序:{{$store.state.tableData_collection_sort.text}}<i class="el-icon-arrow-down el-icon--right"></i></span>
                </span>
                <el-dropdown-menu slot="dropdown" class="el-dropdown-menu-160">
                  <el-dropdown-item
                      :command="it"
                      v-for="(it, index) in dropdown_sort_items"
                      :key="index"
                      >{{ it.text  }}</el-dropdown-item
                    >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="line-cloud"></div>
        </div>

        <div id="lately_list_head">
          <div class="file-item lately-item">
            <div class="file-name file-item-lately">
              <div>名称</div>
            </div>
            <div class="file-update-time list_header_color">日期</div>
            <div class="file-update-form list_header_color">类型</div>
            <div class="file-size list_header_color">大小</div>
            <div class="file-do caozuo-box"></div>
          </div>
        </div>

        
        <div class="lately_list_no" v-if="$store.state.tableData_collection.length == 0">
          <div class="lately_center">
            <div class="lately_list_no_box">
              <img src="@/assets/images/team/no_file.png" alt="" />
              <div class="lately_list_no_th">暂无文件</div>
            </div>
          </div>
        </div>

        <div id="lately_list" v-if="$store.state.tableData_collection.length != 0">
          <div
            class="file-item lately-item"
            :class="cur_click_item_index == i ? 'file-item-active' : ''"
            v-for="(item, i) in $store.state.tableData_collection"
            :key="i"
            @mouseenter="show_share_btn(i)"
            @mouseleave="hide_share_btn(i)"
            @click="is_show_share_click(i)"
            @contextmenu.prevent="show_right_menus_cs($event, item, i)"
          >
            <div class="file-name">
              
              <img
                :src="imgSrc1"
                @click="open_dwg_sc(item)"
                v-if="item.type == 'file'"
              />
              <img
                :src="item.expired ? imgSrc3 : imgSrc2"
                @click="open_dwg_sc(item)"
                v-if="item.type == 'link' || item.type == 'linkfile'"
              />

              <div
                class="file-name-word"
                :title="item.name"
                style="color: rgb(61, 71, 87)"
                @click="open_dwg_sc(item)"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="file-update-time">{{ item.mtime }}</div>
            <div class="file-update-form" :title="item.share_from">
              {{ item.share_from }}
            </div>
            <div class="file-size">{{ item.sizeMB }}</div>
            <div class="caozuo-box">
              <div class="file-more">
                <el-dropdown trigger="click" @command="dropdown_item_btn_sc">
                  <span class="el-dropdown-link">
                    <img src="@/assets/images/cloud/more.png" />
                  </span>
                  <el-dropdown-menu
                    slot="dropdown"
                    class="el-dropdown-menu-160"
                  >
                    <el-dropdown-item
                      :command="item"
                      :type="it.type"
                      :index="i"
                      v-for="(it, index) in dropdown_items"
                      :key="index"
                      :disabled="item.type == 'dir' && !it.is_dir"
                      >{{ it.text }}</el-dropdown-item
                    >
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div
                class="file-collection file_collect"
                title="收藏当前图纸"
                @click="collect_cur_dwg_sc(i, item)"
              >
                <img
                  :src="item.is_collect == 'n' ? is_collect_0 : is_collect_1"
                />
              </div>
              <div
                class="file-share"
                title="生成网页链接发送给他人查看"
                v-show="item.is_show_share"
                @click="send_share_dwg_btn_sc(item)"
              >
                发送图纸
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="filedo-box lately-filedo-box">
        <div class="fdb-item" id="lately_do_open">打开</div>
        <div class="fdb-item" id="lately_do_del">删除</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCollectionFile,
  openCloudfile,
  myCloudCollection_no,
  recent_add
} from "@/api/get_cloud";
import { get_share_code } from "@/api/share";
import utils from "@/utils/utils";

export default {
  name: "My_collection",
  data() {
    return {
      multipleSelection: [],
      zuijin_list: [],
      is_collect_0: require("@/assets/images/cloud/collect.png"),
      is_collect_1: require("@/assets/images/cloud/icon_richeng_star.png"),
      dropdown_items: [
        { text: "打开", type: "open" },
        { text: "发送图纸", type: "share" },
        { text: "取消收藏", type: "collection" },
      ],
      usertoken: '',
      sortFiles: [],
      cur_cloud_sort_type: 'time',
      imgSrc1: require('@/assets/images/cloud/file_cloud.png'),
      imgSrc2: require('@/assets/images/cloud/file_form.png'),
      imgSrc3: require('@/assets/images/cloud/file_gg.png'),
      cur_click_item_index: -1,
      dropdown_sort_items: [
        { text: "名称", type: "name", },
        { text: "日期", type: "time" },
        { text: "类型", type: "type" },
        { text: "大小", type: "size" },
      ],
    };
  },

  created() {
    
  },

  mounted() {
    var USER_TOKEN = JSON.parse(localStorage.getItem("USERTOKEN"));
    if (USER_TOKEN != null) {
      this.usertoken = USER_TOKEN
    }
    this.get_Collection_Files()
  },

  methods: {

    //获取收藏列表
    get_Collection_Files () {
      var send = {
        usertoken: this.usertoken,
        type: 'web'
      }
      this.$store.state.tableData_loading_collection = true;
      getCollectionFile(send).then((res) => {
        var data = JSON.parse(res.data);
        if (data.code == 99) {
          this.login_expired_sc();
          return;
        } else if (data.code == 2) {
          this.login_expired_sc();
        } else if (data.code == 1) {
          this.set_tables_sc(data.data)
        }
      });
    },

    // 渲染前排序
    set_tables_sc(data) {
      var newData = [];
      this.sortFiles = []
      this.sortFiles = data

      this.sortFiles.forEach((item) => {
        item.is_show_share = false;
        item.sizeMB = utils.convert_size_MB(item.file_size);
        item.size = item.file_size
        item.mtime = utils.convert_date_day(item.insert_time)
        item.expired = false
        if (item.link_id == 0) {
          item.is_share = 0
          item.name = item.cloud_path.substring(item.cloud_path.lastIndexOf("/")+1);
          item.type = 'file'
          item.share_from = "我的图纸";
        } else {
          item.is_share = 1
          item.name = item.link_name
          item.type = item.link_type
          // item.expired = item.share_remain_time <= 0 ? true : false
        }
        newData.push(item);
      });
      this.sortFiles = newData
      this.sc_files_sort()
      this.$store.state.tableData_collection = newData;
      this.$store.state.tableData_loading_collection = false;
    },

    //收藏列表进行排序
    sc_files_sort() {
      var cur_cloud_sort_type = this.$store.state.tableData_collection_sort.type
      if (cur_cloud_sort_type == 'time') {
        this.sortFiles.sort(utils.compareTime('insert_time','inverted'))
      } else if (cur_cloud_sort_type == 'size') {
        this.sortFiles.sort((a, b) => parseInt(b.size) - parseInt(a.size));
      } else if (cur_cloud_sort_type == 'name') {
        this.sortFiles.sort((a,b) => {
          return a.name.localeCompare(b.name, 'zh-Hans-CN', {sensitivity: 'accent'});
        })
      } else if (cur_cloud_sort_type == 'type') {
        this.sortFiles.sort(function (a) {
          if(a.type=="file")
            return 1;
          else
            return -1;
        });
      }
    },


   //排序操作
    dropdown_sort_btn_sc(item) {
      this.$store.state.tableData_collection_sort = {
        text: item.text,
        type: item.type
      }
      this.set_tables_sc1(this.$store.state.tableData_collection)
    },

    // 渲染前排序
    set_tables_sc1(data) {
      this.sortFiles = []
      this.sortFiles = data
      this.sc_files_sort()
      this.cur_click_item_index = -1
      this.sortFiles.forEach((item)=>{ item.is_show_share = false })
      this.$store.state.tableData_collection = this.sortFiles;
    },


    //刷新
    refresh_lists_btn_sc() {
      this.$store.state.tableData_loading_collection = true;
      this.get_Collection_Files()
    },


    //登录过期，回到首页
    login_expired_sc() {
      this.$msg.whiteerr('登录信息已过期，请重新登陆')
      this.del_localStorae();
      this.$router.push("/");
    },

    del_localStorae() {
      window.localStorage.removeItem("USER_INFO");
      window.localStorage.removeItem("USERTOKEN");
      window.localStorage.removeItem("USER_INFO_TIME");
    },

    is_show_share_click(i) {
      this.cur_click_item_index = i
      this.$store.state.tableData_collection.forEach((item)=>{
        item.is_show_share = false
      })
      this.$store.state.tableData_collection[i].is_show_share = true;
      this.$store.commit('updateCollectionData', this.$store.state.tableData_collection)
    },

    show_share_btn(i) {
      this.$store.state.tableData_collection[i].is_show_share = true;
      this.$store.commit('updateCollectionData', this.$store.state.tableData_collection)
    },

    hide_share_btn(i) {
      if (this.cur_click_item_index == i) return
      this.$store.state.tableData_collection[i].is_show_share = false;
      this.$store.commit('updateCollectionData', this.$store.state.tableData_collection)
    },

    collect_cur_dwg_sc(i, item) {
      var send;
      if (item.is_share == 1){ 
        send = {
          usertoken: this.usertoken,
          link_id: item.link_id,
        }
      } else {
        send = {
          usertoken: this.usertoken,
          cloud_path: item.cloud_path,
        }
      }
      myCloudCollection_no(send).then((res) => {
        var data = JSON.parse(res.data);
        if (data.code == 99) {
          this.login_expired_sc();
        } else if (data.code == 1) {
          this.$store.state.tableData_collection.splice(i,1)
          this.$msg.white('已取消收藏')
        }
      });
      
    },


    //打开图纸
    open_dwg_sc(item) {
      if (item.expired) { this.$msg.whiteerr('文件分享链接已过期，无法打开');return}
      if (item.type != 'file') {
        this.open_share_url(item)
        return
      }
      var send = {
        cloud_path: item.cloud_path,
        is_mobile: "0",
      };
      // const tempPage = window.open('', '_blank')
      console.log('openCloudfile desk')
      openCloudfile(send).then((res) => {
        var data = JSON.parse(res.data);
        if (data.code == 1) {
          var f_id = data.f_id;
          let file_type = data.file_type;
          if (file_type == '3d') {
            // this.$msg.whiteerr('3D图纸页面正在建设中')
            let pathInfo = this.$router.resolve({
              path: "/cdf",
              query: {
                file_id: f_id,
              },
            });
            this.open_file_recent_add (item.type, item.cloud_path)
            window.open(pathInfo.href, "_blank");
            // tempPage.location = pathInfo.href
          } else {
            let pathInfo = this.$router.resolve({
              path: "/dwg",
              query: {
                file_id: f_id,
              },
            });
            this.open_file_recent_add (item.type, item.cloud_path)
            console.log('openCloudfile desk')
            window.open(pathInfo.href, "_blank");
            // tempPage.location = pathInfo.href
          }
          
        } else if (res.code == 2) {
          this.$msg.whiteerr('文件不存在，可能已被删除')
        } else if (res.code == 3) {
          this.$msg.whiteerr('不支持文件类型')
        } else {
          this.$msg.whiteerr('未知原因，无法打开')
        }
      }).catch(()=>{
        this.$msg.whiteerr('网络开小差了，请稍后再试')
      });;
    },

    //打开文件，添加到最近
    open_file_recent_add (type, value) {
      var send;
      if (type == 'file') {
        var cloud_path = value
        send = {
          usertoken: this.usertoken,
          cloud_path: cloud_path
        }
      }
      recent_add(send).then(()=>{})
    },

     open_share_url(item) {
      if (item.file_type == '3d') {
        let pathInfo = this.$router.resolve({
        path: "/cdf",
        query: {
          share_id: item.share_id,
        },
      });
      window.open(pathInfo.href, "_blank");
      return
      }
      let pathInfo = this.$router.resolve({
        path: "/dwg",
        query: {
          share_id: item.share_id,
          link_id: item.link_id ? item.link_id : ''
        },
      });
      window.open(pathInfo.href, "_blank");
    },

    //操作
    dropdown_item_btn_sc(item, event) {
      var type = event.$attrs.type
      var i = event.$attrs.index;
      if (type == "open") {
        //打开
        this.open_dwg_sc(item)
      } else if (type == "share") {
        this.send_share_dwg_btn_sc(item)
      } else if (type == "collection") {
        this.collect_cur_dwg_sc(i, item);
      }
    },

     // 右键显示菜单
    show_right_menus_cs (event,item, i) {
      this.cur_click_item = item
      this.cur_click_item_index = i
      this.is_show_share_click(i)
      var that = this
      this.$contextmenu({
        items: [
          {
            label: "打开",
            onClick: () => {
              that.open_dwg_sc(item);
            }
          },
          { label: "发送图纸",
            onClick: () => {
              that.send_share_dwg_btn_sc(item)
            }
          },
          { label: "取消收藏", onClick: () => {
              that.collect_cur_dwg_sc(i, item);
            }
          },
        ],
        event,
        //x: event.clientX,
        //y: event.clientY,
        customClass: "class-a",
        zIndex: 3,
        minWidth: 160
      });
      return false;
    },


    send_share_dwg_btn_sc(item) {
      if (item.expired) {this.$msg.whiteerr('文件分享链接已过期，无法操作');return}
      this.$store.state.share_from = 'myzj'
      this.$store.state.is_show_share_box = true;
      this.$store.state.cur_share_data = item;
      this.$store.commit("updateCurShareData_recently", item);
      this.$EventBus.$emit("showShareBox");
      // this.getShareQcode_sc(item);
    },

    //获取分享地址
    getShareQcode_sc(item) {
      // var type = this.$store.state.cur_show_action;
      this.$store.state.share_box_url = "正在努力获取中...";
      if (item.is_share == 1) {
        this.$store.state.share_box_url = item.share_url;
        return
      }
      var share_box_p = item.cloud_path
      var send = {
        type: 0,
        p: share_box_p,
      };
      
      get_share_code(send).then((res) => {
        var data = JSON.parse(res.data);
        if (data.code == 1) {
          var url = data.url;
          this.$store.state.share_box_url = url;
        } else if (data.code == 4) {
          this.$msg.whiteerr('文件不存在，可能已经删除')
        } else if (data.code == 99) {
          this.login_expired_sc();
        }
      });
    },
  },
};
</script>


<style lang="less" scoped>
.el-dropdown-menu-160 {
  width: 160px;
}

.el-dropdown-menu-160 li {
  height: 30px;
  line-height: 30px;
}

.con-right-box {
  margin-top: 24px;
  margin-left: 30px;
  min-width: 0px;
  width: 100%;
  height: 100%;
}

.el-table .el-table__cell {
  text-align: center;
}

.cloud_path {
  font-size: 16px;
  color: #4383f0;
}

.lately_list_no_box {
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.lately_list_no_box img {
  width: 110px;
  height: 110px;
}

.lately_list_no_th {
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #333333;
  padding-top: 10px;
  padding-bottom: 30px;
}

.lately_list_no_text {
  width: 140px;
  height: 42px;
  line-height: 42px;
  background-image: linear-gradient(129deg, #4383f0 0%, #50acf9 100%);
  border-radius: 4px;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}

#lately_list {
  height: calc(100% - 130px);
  overflow: auto;
  min-width: 836px;
}

.file-update-form {
  width: 17%;
  color: #767c85;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  font-size: 12px;
}

.file_collect {
  display: block;
}

.file_collect img {
  width: 20px;
  height: 20px;
}

#lately_list_head {
  min-width: 836px;
}

.file-item {
  height: 54px;
  line-height: 54px;
  display: flex;
  flex-direction: row;
  font-size: 14px;
  align-items: center;
}

.file-item-active {
  background-color: #f0f4fc;
}

.file-item:hover {
  background-color: #f0f4fc;
}

.lately_center {
  height: calc(100% - 60px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.file-name img {
  cursor: pointer;
}

.files-table {
  margin-right: 30px;
}

.lately_file_header {
  margin-right: 0;
}

.filedo-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 160px;
  background-color: #fff;
  border: 1px solid #d3d3d3;
  box-shadow: 0 2px 12px 0 rgb(56, 56, 56, 0.2);
  font-size: 13px;
  color: #666;
  display: none;
}

.fdb-item {
  width: 100%;
  height: 30px;
  line-height: 30px;
  text-indent: 20%;
  cursor: pointer;
}

.fdb-item:hover {
  background-color: #f2f5fa;
}

.caozuo-box {
  height: 22px;
}
</style>